module.exports = __webpack_public_path__ + "static/img/Bachelor_010734.486a8cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010734.jpg
// module id = 235
// module chunks = 0